import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { FinancialState } from './state';

const defaultState: FinancialState = {
  financials: [],
  unattestedAppointments: [],
  appointmentsWithoutPrescription: [],
};

export const financialsModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
